import React, { useEffect, useContext, useState } from "react"
import { AppContext } from "./index"
import Tareas from "./Tareas"


export default function MisTareas() {
    let { firebase, usrLogged } = useContext(AppContext);
    const [tareas, setTareas] = useState(firebase.misTareas(usrLogged.id))
    let grupo = ["Prioritarias", "15 dias", "Mediano plazo"]

    useEffect(() => {
        document.getElementById("htmlTituloPag").innerHTML = "Mis Tareas"
        setTareas(firebase.misTareas(usrLogged.id))
    }, [firebase, usrLogged.id]);

    if (usrLogged.isLogged) {
        return (
            <div sytle={SmisTareas}>
                <div style={Scolumna}>
                    {grupo.map(g =>
                        <div key={g}>
                            <Tareas tareas={tareas[g]} grupo={g} />
                        </div>
                    )}
                </div >
            </div>
        )
    } else return <div>Debe loguearse, gil!!</div>;
}

const SmisTareas = {
    width: "94vh",
}

const Scolumna = {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-evenly",
    marginTop: "15px"
}



